import { Pipe, PipeTransform } from '@angular/core';
import { resolveDotNotationPath } from '../../_core/utils/object.utils';

@Pipe({
	name: 'orderByAlpha'
})
export class OrderByAlphaPipe implements PipeTransform {
	transform(array: any[], path: string): any[] {
		array?.sort((a: any, b: any) => {
			console.log(path);
			let aValue = resolveDotNotationPath(path, a);
			let bValue = resolveDotNotationPath(path, b);

			if (aValue < bValue) {
				return -1;
			} else if (aValue > bValue) {
				return 1;
			} else {
				return 0;
			}
		});
		return array;
	}
}
